module.exports = __webpack_public_path__ + "static/list-d6e3ca5cf6e98cf2d618227cd189f5f9.png";